import { createContext, useContext } from 'react';
export const BootstrapContext = createContext(null);
export function useBootstrap() {
    const ctx = useContext(BootstrapContext);
    if (!ctx)
        throw new Error('useBootstrap must be used within BootstrapContext.Provider');
    return ctx;
}
